import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const EntraIdLogin = () => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        if (accounts.length > 0) {
            navigate("/home");
        }
    }, [accounts, navigate]);

    const handleLogin = () => {
        console.log("**** instance", instance);

        instance.loginRedirect(loginRequest).catch(e => {
            console.error("Login error:", e);
        });
    };

    return (
        <div style={{
            minHeight: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)"
        }}>
            <div style={{
                width: "400px",
                backgroundColor: "white",
                borderRadius: "8px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                padding: "60px 50px",
                textAlign: "center"
            }}>
                <img 
                    src="/favicon-tls-64x64.png" 
                    alt="Logo" 
                    style={{ width: "100px", marginBottom: "40px" }} 
                />
                <h1 style={{
                    fontSize: "28px",
                    fontWeight: "400",
                    color: "#333",
                    marginBottom: "40px"
                }}>Dose Service Tool</h1>
                <button 
                    onClick={handleLogin}
                    style={{
                        width: "100%",
                        backgroundColor: "#0066cc",
                        color: "white",
                        border: "none",
                        padding: "14px",
                        fontSize: "16px",
                        fontWeight: "500",
                        borderRadius: "4px",
                        cursor: "pointer",
                        transition: "background-color 0.2s ease"
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = "#0052a3"}
                    onMouseOut={(e) => e.target.style.backgroundColor = "#0066cc"}
                >
                    Sign In
                </button>
            </div>
        </div>
    );
};

export default EntraIdLogin;
